<template>
  <b-pagination
    v-model="currentPage"
    :total-rows="totalRows"
    :per-page="perPage"
    size="sm"
    @change="(arg) => $emit('change', arg)"
    class="mt-3"
  >
    <template #prev-text>
      <i class="material-icons" style="font-size: 16px;">chevron_left</i>
    </template>
    <template #next-text>
      <i class="material-icons" style="font-size: 16px;">chevron_right</i>
    </template>
  </b-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  model: { prop: 'currentPage', event: 'change' },
  props: {
    perPage: { type: Number, default: 15 },
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
  },
};
</script>
